class DefaultNewsletterForm extends HTMLElement {
  constructor() {
    super();
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  connectedCallback() {
    const zapierUtmSources = ['edm', 'social', 'pr', 'kol', 'affiliate'];
    const utmSource = (
      new URLSearchParams(window.location.search).get('utm_source') || ''
    ).trim().toLowerCase();

    if (zapierUtmSources.includes(utmSource)) {
      this.style.display = 'none';
      return;
    }

    this.style.display = '';
    this._tag = utmSource === 'paid'
      ? (this.getAttribute('paid-tag') || 'grandflux_paid_waitlist')
      : (this.getAttribute('default-tag') || 'nexus_waitlist');

    this.addEventListener('submit', this.handleFormSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.handleFormSubmit);
  }

  handleFormSubmit() {
    const tagEl = this.querySelector('.default-form-tag');
    if (tagEl) tagEl.value = this._tag;
  }
}

if (!customElements.get('default-newsletter-form')) {
  customElements.define('default-newsletter-form', DefaultNewsletterForm);
}

class ZapierNewsletterForm extends HTMLElement {
  constructor() {
    super();
    this._hideTimer = null;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    const zapierUtmSources = ['edm', 'social', 'pr', 'kol', 'affiliate'];
    const utmSource = (
      new URLSearchParams(window.location.search).get('utm_source') || ''
    ).trim().toLowerCase();

    const myUtm = this.getAttribute('zapier-tag') || '';

    if (!zapierUtmSources.includes(utmSource) || utmSource !== myUtm) {
      this.style.display = 'none';
      return;
    }

    this.style.display = '';
    this.addEventListener('click', this.handleSubmit);
    this.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleSubmit);
    this.removeEventListener('keydown', this.handleKeydown);
  }

  get zapierUrl() { return this.getAttribute('zapier-url') || ''; }
  get zapierTag() { return this.getAttribute('zapier-tag') || ''; }
  get input()     { return this.querySelector('input[type="email"]'); }
  get btn()       { return this.querySelector('button[type="button"]'); }
  get successEl() { return this.querySelector('[data-banner="success"]'); }
  get errorEl()   { return this.querySelector('[data-banner="error"]'); }

  handleSubmit(e) {
    if (!e.target.closest('button[type="button"]')) return;
    this.submit();
  }

  handleKeydown(e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    if (!e.target.closest('input[type="email"]')) return;
    this.submit();
  }

  showBanner(el) { if (el) el.style.display = 'block'; }
  hideBanner(el) { if (el) el.style.display = 'none'; }

  showSuccess() {
    if (this._hideTimer) clearTimeout(this._hideTimer);
    this.hideBanner(this.errorEl);
    this.showBanner(this.successEl);
  }

  showError() {
    if (this._hideTimer) clearTimeout(this._hideTimer);
    this.hideBanner(this.successEl);
    this.showBanner(this.errorEl);
    this._hideTimer = setTimeout(() => this.hideBanner(this.errorEl), 10000);
  }

  submit() {
    const email = this.input ? this.input.value.trim() : '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) { this.showError(); return; }
    if (!this.zapierUrl)         { this.showError(); return; }

    if (this.btn) this.btn.disabled = true;

    fetch(this.zapierUrl, {
      method: 'POST',
      body: JSON.stringify({ phone: '', email, tag: this.zapierTag })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          if (this.input) this.input.value = '';
          this.showSuccess();
        } else {
          this.showError();
        }
      })
      .catch(() => this.showError())
      .finally(() => { if (this.btn) this.btn.disabled = false; });
  }
}

if (!customElements.get('zapier-newsletter-form')) {
  customElements.define('zapier-newsletter-form', ZapierNewsletterForm);
}
